import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Models
export interface staging {
  id: number;
  cif: number;
  name: string;
  financial_status: string;
  stage: number;
  class_type: string;
  // type_id: number;
onBalanceOutstanding:number;
offBalanceOutstanding:number;
limitOutstanding:number;
total_outstanding_lcy:number;
  year: number;
  quarter: string;
  account_types: string[];
  currentPage: number;
  lastPage: number;
  pagesCount: number;
  selectedClients: number[];
}

// clients state
export interface StagingState {
  isLoaded: boolean; // First load
  isLoading: boolean; // On filtering laoder
  isFetching: boolean;
  hasMore: boolean;
  staging_list: staging[];
  filtersComplete: boolean;
  currentPage: number;
  lastPage: number;
  pagesCount: number;
  selectedClients: number[];
}

const initialState: StagingState = {
  isLoaded: false,
  isLoading: false,
  isFetching: false,
  hasMore: true,
  staging_list: [],
  filtersComplete: false,
  currentPage: 1,
  lastPage: 1,
  pagesCount: 1,
  selectedClients: [],
};

// Staging slice
export const StagingSlice = createSlice({
  name: "staging",
  initialState,
  reducers: {
    setIsLoaded: (state, { payload }: PayloadAction<boolean>) => {
      state.isLoaded = payload;
    },

    deleteirs_profile: (state, { payload }: PayloadAction<number[]>) => {
      payload.forEach((id) => {
        const index = state.staging_list.findIndex((pd) => pd.id === id);
        if (index !== -1) state.staging_list.splice(index, 1);
      });
    },

    setFiltersComplete: (state, action: PayloadAction<boolean>) => {
      state.filtersComplete = action.payload;
    },

    setIsLoading: (state, { payload }: PayloadAction<boolean>) => {
      state.isLoading = payload;
    },
    setIsFetching: (state, { payload }: PayloadAction<boolean>) => {
      state.isFetching = payload;
    },
    setHasMore: (state, { payload }: PayloadAction<boolean>) => {
      state.hasMore = payload;
    },
    setStaging: (state, { payload }: PayloadAction<staging[]>) => {
      state.staging_list = payload;
    },

    setCurrentPage: (state, { payload }: PayloadAction<number>) => {
      state.currentPage = payload;
    },

    setLastPage: (state, { payload }: PayloadAction<number>) => {
      state.lastPage = payload;
    },
    setPagesCount: (state, { payload }: PayloadAction<number>) => {
      state.pagesCount = payload;
    },
    clearStaging: (state) => {
      state.isFetching = false;
      state.staging_list = [];
    },
    reset: (state) => {
      (state.isLoading = false),
        (state.isFetching = false),
        (state.hasMore = true);
      state.staging_list = [];
      state.currentPage = 1;
      state.lastPage = 1;
      state.pagesCount = 1;
    },
    toggleClientSelection: (state, { payload }: PayloadAction<number>) => {
      if (state.selectedClients.includes(payload)) {
        state.selectedClients = state.selectedClients.filter(
          (cif) => cif !== payload
        );
      } else {
        state.selectedClients.push(payload);
      }
    },

 selectAllClients: (state) => {
  const pageCifs = state.staging_list.map(client => client.cif);
  state.selectedClients = Array.from(new Set([...state.selectedClients, ...pageCifs]));
},
unselectAllClients: (state) => {
  const pageCifs = state.staging_list.map(client => client.cif);
  state.selectedClients = state.selectedClients.filter(cif => !pageCifs.includes(cif));
},


    clearSelectedClients: (state) => {
  state.selectedClients = [];
},
  },
});
